import React, { useEffect, useRef } from "react";
import flatpickr from "flatpickr";
import "flatpickr/dist/themes/material_blue.css";

const FlatpickrDateInput = ({ value, onChange }) => {
  const inputRef = useRef(null);
  const flatpickrInstance = useRef(null);

  useEffect(() => {
    flatpickrInstance.current = flatpickr(inputRef.current, {
      dateFormat: "d/m/Y",
      defaultDate: value,
      onChange: ([selectedDate]) => {
        if (selectedDate) {
          const day = String(selectedDate.getDate()).padStart(2, "0");
          const month = String(selectedDate.getMonth() + 1).padStart(2, "0");
          const year = selectedDate.getFullYear();
          const formatted = `${day}/${month}/${year}`;
          onChange(formatted);
        }
      },
    });

    return () => {
      if (flatpickrInstance.current) {
        flatpickrInstance.current.destroy();
      }
    };
  }, []);

  // Always update the input's visible value manually
  useEffect(() => {
    if (inputRef.current && value) {
      inputRef.current.value = value;
    }
  }, [value]);

  return (
    <input
      type="text"
      ref={inputRef}
      className="form-register-input-impact"
      placeholder="Select date"
      readOnly // recommended to prevent user manual typing
    />
  );
};

export default FlatpickrDateInput;
